import { combineReducers } from '@reduxjs/toolkit';

import QAAdminReducer from './QA/slice';

export default combineReducers({
  qa: QAAdminReducer,
});
